import React,{useMemo} from 'react';
import { Link } from 'react-router-dom'//yarn add @types/react-router-dom
//import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
//import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
//import Button from '@mui/material/Button';
//import Badge, { BadgeProps } from '@mui/material/Badge';

import Collapse from '@mui/material/Collapse';
import StoreIcon from '@mui/icons-material/Store';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BookIcon from '@mui/icons-material/Book';
import PortraitIcon from '@mui/icons-material/Portrait';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
//import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import useStyles from './Styles';
//import ChangeOwner from './ChangeOwner';
import {Owner} from './Inc';


interface Props {
    onClick():void,
    owner: Owner,
}

//const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
//	'& .MuiBadge-badge': {
//	  right: -8,
//	  top: 12,
//	  border: `2px solid ${theme.palette.background.paper}`,
//	  padding: '0 4px',
//	},
//  }));

const menuLarges = ['ホーム','商品と納品','電子書籍','販売管理','作家'];
const menuMediums = [
    [["","ダッシュボード"],["about","架空ストアとは？"],["first","ご利用ガイド"],["help","ヘルプ！"],["first/input","事前審査"],["kbin","Ｋ便鉄道コラボ"],["inquiry","お問い合わせ"],["company","運営会社"]],
    [["item","商品"],["page","シリーズ"],["label","ラベル"],["sort","商品表示順"],["consign","納品"],["return","商品引取"],["zaiko","在庫確認"],["kbin/list","Ｋ便鉄道参加"],["visit","井の頭倉庫（休止）"]],
    [["book","戯曲"]],
    [["plan","発売日"],["secret","シークレット"],["sale","売上履歴"],["lottery","抽選受付履歴"],["payment","売上残高と支払申請"],["mails","メール通知"],["fav","スキ"],["request","買いたい！"]],
    [["profile","プロフィール"],["floor","引っ越し"],["event","参加イベント"],["customer","連絡先"],["bank","支払口座"],["news","ニュース"],["bye","退会"]],
    [["profile","プロフィール"],["customer","連絡先"],["bye","退会"]],//作家登録まだ
    [["profile","プロフィール"]],//会員登録まだ（ログインしていない）
]
const menuIcons = [<StoreIcon />,<ShoppingCartIcon />,<BookIcon />,<TrendingUpIcon />,<PortraitIcon />,<AssignmentIcon />];

const Menus = (props:Props)=> {
    const classes = useStyles();
    const [opens, setOpens] = React.useState([false,false,false,false]);
    const handleClick = (index:number)=>{
        let flags = [false,false,false,false];
        flags[index] = !opens[index];
        setOpens(flags);
    }
    const sidemenus = useMemo( ()=>{return menuLarges.map((name, index) => {
        if( props.owner.owner_id===0 && (index>0 && index<4) ){
            return (null);
        }

        let no = index;
        if( props.owner.owner_id===0 && index===4 ){
            if( props.owner.customer.customer_id===0 ){
                no = 6;
            } else {
                no = 5;
            }
        }

        const links = menuMediums[no].map( (data2,index2)=>{
            const key = "link"+index2;
            if( data2[0].substr(0,1)!=="/" ){
                const to = "/"+data2[0];
                return (
                    <Link key={key} to={to} onClick={props.onClick} style={{textDecoration:"none",color:"#333333"}}>
                        <ListItem button className={classes.nested}>
                            <ListItemText primary={"・"+data2[1]}/>
                        </ListItem>
                    </Link>
                )
            } else {
                return (
                    <a key={key} href={data2[0]} onClick={props.onClick} style={{textDecoration:"none"}}>
                        <ListItem button className={classes.nested}>
                            <ListItemText primary={"・"+data2[1]}/>
                        </ListItem>
                    </a>
                )
            }
        });
        const key = "menu"+index;
        return (
            <nav key={key}>
                <ListItem button onClick={()=>handleClick(index)}>
                    <ListItemIcon style={{marginRight:"-1.5em",color:"#484858"}}>
                        {menuIcons[index]}
                    </ListItemIcon>
                    <ListItemText primary={name}/>
                    {opens[index] ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={opens[index]} timeout="auto" style={{marginBottom:"1em"}} unmountOnExit>
                    <List disablePadding>
                        {links}
                    </List>
                </Collapse>
            </nav>
        );
    })},[opens,props.owner]);

	// let toTop = process.env.REACT_APP_STOREURL;
	// let toProfile = process.env.REACT_APP_STOREURL + "/profile_o"+props.owner.owner_id+".html";
	// let toList = process.env.REACT_APP_STOREURL + "/list_o"+props.owner.owner_id+".html";
	// let toMypage = process.env.REACT_APP_STOREURL + "/mypage_index.html";

	let toTop = process.env.REACT_APP_DEPARTURL;
	let toProfile = process.env.REACT_APP_DEPARTURL + "/items/owner/"+props.owner.owner_id;
	//let toList = process.env.REACT_APP_DEPARTURL + "/list_o"+props.owner.owner_id+".html";
	let toMypage = process.env.REACT_APP_DEPARTURL + "/account";

    return (
		<>
        <List>
            {sidemenus}
			<Divider style={{marginTop:"2em",marginBottom:"1em"}}/>
			<ListItem dense>
			架空ストアを見る
			</ListItem>
            <ListItem button dense>
                <a href={toTop} rel="noopener noreferrer" target="_blank" className="withIcon" style={{color:"#333333"}}><ArrowForwardIcon style={{marginRight:"0.3em"}}/>エントランス</a>
            </ListItem>
			{props.owner.owner_id===0 ? (
			<React.Fragment>
				<ListItem button dense disabled>
					<a href={toProfile} rel="noopener noreferrer" target="_blank" className="withIcon" style={{color:"#333333"}}><ArrowForwardIcon style={{marginRight:"0.3em"}}/>商品リスト</a>
				</ListItem>
			</React.Fragment>
			):(
			<React.Fragment>
				<ListItem button dense>
					<a href={toProfile} rel="noopener noreferrer" target="_blank" className="withIcon" style={{color:"#333333"}}><ArrowForwardIcon style={{marginRight:"0.3em"}}/>商品リスト</a>
				</ListItem>
				<ListItem button dense>
					<a href={toMypage} rel="noopener noreferrer" target="_blank" className="withIcon" style={{color:"#333333"}}><ArrowForwardIcon style={{marginRight:"0.3em"}}/>マイページ</a>
				</ListItem>
			</React.Fragment>
			)}
        </List>
		</>
    );
}

export default Menus;
